var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteOneDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 48,
    viewBox: "0 0 75 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.263 32.392L60.7276 17.6029C57.5153 5.07727 44.7572 -2.47271 32.2315 0.739596C26.5908 2.18622 21.6917 5.68287 18.4902 10.5471C18.7295 10.541 45.263 32.392 45.263 32.392Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5689 13.3314L28.5682 13.334C25.6132 11.5038 22.2053 10.5364 18.7295 10.5412C18.6492 10.5412 18.5703 10.5462 18.4902 10.5472C8.151 10.6753 -0.12655 19.1606 0.00146504 29.4995C0.0478771 33.2498 1.2197 36.8998 3.36506 39.9763L26.5335 37.0746L44.2963 22.7518L28.5689 13.3314Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7271 17.6029C60.3872 17.5802 60.0456 17.5645 59.6999 17.5645C57.6252 17.5624 55.5722 17.9862 53.6679 18.8095L53.6675 18.8079L44.2959 22.7516L54.6274 35.5135L73.0975 40.0034C77.0834 32.6038 74.3159 23.3742 66.9164 19.3883C65.0044 18.3584 62.8941 17.7496 60.7273 17.6029L60.7271 17.6029Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36523 39.9761C6.86354 45.0058 12.6031 48.0032 18.7297 47.9999H59.7004C65.2971 48.0015 70.4428 44.9303 73.0979 40.0036L44.2964 22.7516L3.36523 39.9761Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteOneDrive);
export default __webpack_public_path__ + "static/media/whiteOneDrive.7e687d33734dfa5e54b12860b8425561.svg";
export { ForwardRef as ReactComponent };